<template>
  <v-main>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" width="auto">
      <v-card>
        <v-card-title> Informations </v-card-title>
        <v-card-text>
          {{ msg_dialog }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-img
          src="@/assets/FIRSILOGO.png"
          contain
          max-height="50"
          max-width="150"
          class="mr-2"
        ></v-img>
      </v-col>
    </v-row>
    <v-btn class="ma-2" color="secondary" large @click="BackToList()">
      <v-icon start large>{{ icons.mdiArrowLeftThick }}</v-icon>
      Retour à la liste
    </v-btn>
    <v-form
      v-show="!msg_erreur"
      ref="formulaire"
      v-model="valid"
      lazy-validation
    >
      <h1>Informations personnelles</h1>
      <v-row>
        <v-col cols="4">
          <v-text-field
            label="N° CNI"
            v-model="$storeDossierBourse.Formulaire.NCNI"
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Nom *"
            v-model="$storeDossierBourse.Formulaire.Nom"
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Prénom *"
            v-model="$storeDossierBourse.Formulaire.Prenom"
            disabled
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Genre *"
            v-model="$storeDossierBourse.Formulaire.Genre"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.Genre"
            disabled
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Email personnel *"
            v-model="$storeDossierBourse.Formulaire.EmailPerso"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
            @change="onEmailChange"
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Email école"
            v-model="$storeDossierBourse.Formulaire.EmailEcole"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            label="Téléphone *"
            v-model="$storeDossierBourse.Formulaire.TelephoneMaroc"
            :rules="$storeReglesBourse.obligatoire"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="4"
          v-show="
            this.$storeDossierBourse.Formulaire.Programmes.indexOf(
              $storeCatalogue.ProgrammeGefDataId
            ) > -1
          "
        >
          <v-text-field
            label="Téléphone en France *"
            v-model="$storeDossierBourse.Formulaire.TelephoneFrance"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="
              !$storeDossierBourse.Formulaire.PremierDossier &&
              this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                $storeCatalogue.ProgrammeGefDataId
              ) > -1
                ? $storeReglesBourse.obligatoire
                : []
            "
          >
          </v-text-field>
        </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
      <div
        v-show="
          this.$storeDossierBourse.Formulaire.Programmes.indexOf(
            $storeCatalogue.ProgrammeGefDataId
          ) > -1
        "
      >
        Adresse en France
        <v-divider></v-divider>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Adresse en France *"
              v-model="$storeDossierBourse.Formulaire.AdresseFrance"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Code postal en France *"
              v-model="$storeDossierBourse.Formulaire.CpFrance"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Ville en France *"
              v-model="$storeDossierBourse.Formulaire.VilleFrance"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="Région en France *"
              v-model="$storeDossierBourse.Formulaire.RegionFrance"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.RegionFrance"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="Département en France *"
              v-model="$storeDossierBourse.Formulaire.DepartementFrance"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.DepartementFrance"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="Pays"
              v-model="$storeDossierBourse.Formulaire.PaysFrance"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.Pays"
              disabled
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
      Adresse au Maroc
      <v-divider></v-divider>
      <v-row>
        <v-col cols="4">
          <v-text-field
            label="Adresse au Maroc *"
            v-model="$storeDossierBourse.Formulaire.AdresseMaroc"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Code postal au Maroc *"
            v-model="$storeDossierBourse.Formulaire.CpMaroc"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Ville au Maroc *"
            v-model="$storeDossierBourse.Formulaire.VilleMaroc"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Province au Maroc *"
            v-model="$storeDossierBourse.Formulaire.ProvinceMaroc"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.Province"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
            @change="ProvinceChange"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            label="Région au Maroc *"
            v-model="$storeDossierBourse.Formulaire.RegionMaroc"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.Region"
            disabled
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            label="Pays *"
            v-model="$storeDossierBourse.Formulaire.PaysMaroc"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.Pays"
            disabled
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Année scolaire"
            v-model="$storeDossierBourse.Formulaire.AnneeScolaire"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.AnneeScolaire"
            disabled
          ></v-autocomplete>
        </v-col>
        <v-col cols="4"> </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
      <h1>Informations générales</h1>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Dernière année scolaire"
            v-model="$storeDossierBourse.Formulaire.DernierEtat"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.EtatAnnee"
            disabled
            v-show="!this.$storeDossierBourse.Formulaire.PremierDossier"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4" v-show="!this.$storeDossierBourse.Formulaire.PremierDossier && $storeDossierBourse.Formulaire.DernierEtat != null">
          <v-text-field
            label="Spécialité de formation *"
            v-model="$storeDossierBourse.Formulaire.SpecialiteFormation"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            :rules="!this.$storeDossierBourse.Formulaire.PremierDossier && $storeDossierBourse.Formulaire.DernierEtat != null ? $storeReglesBourse.obligatoire : []"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Etat *"
            v-model="$storeDossierBourse.Formulaire.Etat"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.EtatAnnee"
            :disabled="
              $storeDossierBourse.Formulaire.ReadOnly ||
              this.$storeDossierBourse.Formulaire.PremierDossier
            "
            :rules="$storeReglesBourse.obligatoire"
            @change="EtatChange()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            label="Programme"
            v-model="$storeDossierBourse.Formulaire.Programmes"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.Programme"
            multiple
            disabled
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Ecole"
            v-model="$storeDossierBourse.Formulaire.LabelEcole"
            readonly
            disabled
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            label="Je souhaite bénéficier de la bourse"
            v-model="$storeDossierBourse.Formulaire.SouhaireBeneficierBourse"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.SouhaiteBourse"
            v-show="
              $storeDossierBourse.Formulaire.Etat ==
              $storeCatalogue.DataId.DigitalYear
            "
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-show="$storeDossierBourse.Formulaire.NumDossier"
            label="N° Dossier boursier"
            v-model="$storeDossierBourse.Formulaire.NumDossier"
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
      <div
        v-show="
          $storeDossierBourse.Formulaire.Etat !=
          $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee
        "
      >
        <h1>Informations stage, alternance et contrat professionnel</h1>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="Type *"
              v-model="$storeDossierBourse.Formulaire.Type"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.TypeAnnee"
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                $storeDossierBourse.Formulaire.Etat !=
                $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="Durée *"
              v-model="$storeDossierBourse.Formulaire.Duree"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.Duree"
              v-show="
                $storeDossierBourse.Formulaire.Type &&
                $storeDossierBourse.Formulaire.Type !=
                  $storeCatalogue.DataId.AucunType
              "
              :rules="
                $storeDossierBourse.Formulaire.Etat !=
                  $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee &&
                $storeDossierBourse.Formulaire.Type &&
                $storeDossierBourse.Formulaire.Type !=
                  $storeCatalogue.DataId.AucunType
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="Prise en charge frais scolarité *"
              v-model="
                $storeDossierBourse.Formulaire.PriseEnChargeDesFraisDeScolarite
              "
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.FraisScolaritePrisEnCharge"
              v-show="
                $storeDossierBourse.Formulaire.Type &&
                $storeDossierBourse.Formulaire.Type !=
                  $storeCatalogue.DataId.AucunType
              "
              :rules="
                $storeDossierBourse.Formulaire.Etat !=
                  $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee &&
                $storeDossierBourse.Formulaire.Type &&
                $storeDossierBourse.Formulaire.Type !=
                  $storeCatalogue.DataId.AucunType
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div
        v-show="
          this.$storeDossierBourse.Formulaire.Programmes.indexOf(
            $storeCatalogue.ProgrammeGefDataId
          ) > -1
        "
      >
        <h1>Informations administratives</h1>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Montant des frais de scolarité (en euros) *"
              v-model="$storeDossierBourse.Formulaire.MontantDesFraisScolaire"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :prepend-inner-icon="icons.mdiCurrencyEur"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="BCS *"
              v-model="$storeDossierBourse.Formulaire.BCS"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.OuiNon"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4"> </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="CVEC *"
              v-model="$storeDossierBourse.Formulaire.CVEC"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.OuiNon"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Frais de CVEC (en euros) *"
              v-model="$storeDossierBourse.Formulaire.FraisDeCVEC"
              v-show="
                $storeDossierBourse.Formulaire.CVEC ==
                $storeCatalogue.DataId.Oui
              "
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1 &&
                $storeDossierBourse.Formulaire.CVEC ==
                  $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :prepend-inner-icon="icons.mdiCurrencyEur"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4"> </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="Bénéficiaire d'une autre bourse ? *"
              v-model="$storeDossierBourse.Formulaire.BeneficiaireAutreBourse"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.OuiNon"
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="4"> </v-col>
          <v-col cols="4"> </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="Nom bourse *"
              v-model="$storeDossierBourse.Formulaire.NomBourse"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.NomBourse"
              v-show="
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                $storeCatalogue.DataId.Oui
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                this.$storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGefDataId
                ) > -1 &&
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                  $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Montant autre bourse (en euros) *"
              v-model="$storeDossierBourse.Formulaire.MontantAutreBourse"
              v-show="
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                $storeCatalogue.DataId.Oui
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :prepend-inner-icon="icons.mdiCurrencyEur"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Nom autre bourse *"
              v-model="$storeDossierBourse.Formulaire.NomAutreBourse"
              v-show="
                $storeDossierBourse.Formulaire.NomBourse ==
                  $storeCatalogue.DataId.AutreBourse &&
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                  $storeCatalogue.DataId.Oui
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                $storeDossierBourse.Formulaire.NomBourse ==
                  $storeCatalogue.DataId.AutreBourse &&
                $storeDossierBourse.Formulaire.BeneficiaireAutreBourse ==
                  $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            >
            </v-text-field>
          </v-col>
        </v-row>
      </div>
      <div v-show="!this.$storeDossierBourse.Formulaire.PremierDossier">
        <h1>Mobilité internationale</h1>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              label="Mobilité internationale *"
              v-model="$storeDossierBourse.Formulaire.MobiliteInternationale"
              item-text="lang00"
              item-value="id"
              :items="$storeCatalogue.OuiNon"
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                !this.$storeDossierBourse.Formulaire.PremierDossier
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="échange/mobilité internationales *"
              v-model="
                $storeDossierBourse.Formulaire.NomEchangeMobiliteInternationale
              "
              v-show="
                $storeDossierBourse.Formulaire.MobiliteInternationale ==
                $storeCatalogue.DataId.Oui
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                !this.$storeDossierBourse.Formulaire.PremierDossier &&
                $storeDossierBourse.Formulaire.MobiliteInternationale ==
                  $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.obligatoire
                  : []
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="montant bourse mobilité (en euros) *"
              v-model="$storeDossierBourse.Formulaire.MontantBourseMobilite"
              v-show="
                $storeDossierBourse.Formulaire.MobiliteInternationale ==
                $storeCatalogue.DataId.Oui
              "
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                !this.$storeDossierBourse.Formulaire.PremierDossier &&
                $storeDossierBourse.Formulaire.MobiliteInternationale ==
                  $storeCatalogue.DataId.Oui
                  ? $storeReglesBourse.EstNumeriqueObligatoire
                  : []
              "
              :prepend-inner-icon="icons.mdiCurrencyEur"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </div>
      <h1>Informations bancaires</h1>
      <v-row v-show="$storeDossierBourse.Formulaire.IbanExistant">
        <v-col cols="4">
          <v-text-field
            label="IBAN"
            v-model="$storeDossierBourse.Formulaire.IbanExistant"
            disabled
            readonly
          >
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="BIC"
            v-model="$storeDossierBourse.Formulaire.BicExistant"
            disabled
            readonly
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-show="$storeDossierBourse.Formulaire.NoCompteExistant">
        <v-col cols="4">
          <v-text-field
            label="N° compte bancaire Marocain"
            v-model="$storeDossierBourse.Formulaire.NoCompteExistant"
            disabled
            readonly
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row
        v-show="
          $storeDossierBourse.Formulaire.NoCompteExistant ||
          $storeDossierBourse.Formulaire.IbanExistant
        "
      >
        <v-col cols="4">
          <v-autocomplete
            label="Avez-vous changer votre compte bancaire ? *"
            v-model="$storeDossierBourse.Formulaire.ChangerCompteBancaire"
            item-text="lang00"
            item-value="id"
            :items="$storeCatalogue.OuiNon"
            :disabled="$storeDossierBourse.Formulaire.ReadOnly"
            @change="ChangementCompteBancaire"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <div
        v-show="
          $storeDossierBourse.Formulaire.Programmes.indexOf(
            $storeCatalogue.ProgrammeGefDataId
          ) > -1 &&
          ($storeDossierBourse.Formulaire.ChangerCompteBancaire ==
            $storeCatalogue.DataId.Oui ||
            !$storeDossierBourse.Formulaire.IbanExistant)
        "
      >
        Merci de renseigner votre compte bancaire en France.
        <v-row>
          <v-col cols="4">
            <v-text-field
              ref="iban"
              label="IBAN *"
              v-model="$storeDossierBourse.Formulaire.Iban"
              @keydown="VerifierIban"
              @change="VerifierIban"
              :rules="[IsIban, $storeReglesBourse.obligatoire]"
              :disabled="
                $storeDossierBourse.Formulaire.ReadOnly &&
                !$storeDossierBourse.Formulaire.IbanModifiable
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="BIC *"
              v-model="$storeDossierBourse.Formulaire.BIC"
              :rules="[$storeReglesBourse.TailleBic,$storeReglesBourse.obligatoire]"
              :disabled="
                $storeDossierBourse.Formulaire.ReadOnly &&
                !$storeDossierBourse.Formulaire.IbanModifiable
              "
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="4"
            v-show="$storeDossierBourse.Formulaire.IbanModifiable"
          >
            <v-btn large dark color="secondary" @click="SaveIban()">
              Enregistrer
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div
        v-show="
          ($storeDossierBourse.Formulaire.Lydex &&
            $storeDossierBourse.Formulaire.Etat ==
              $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee) ||
          $storeDossierBourse.Formulaire.Programmes.indexOf(
            $storeCatalogue.ProgrammeGemDataId
          ) > -1
        "
      >
        Merci de renseigner votre compte bancaire au Maroc.
        <v-row
          v-show="
            $storeDossierBourse.Formulaire.ChangerCompteBancaire ==
              $storeCatalogue.DataId.Oui ||
            !$storeDossierBourse.Formulaire.NoCompteExistant
          "
        >
          <v-col cols="6">
            <v-text-field
              label="N° du compte bancaire Marocain *"
              v-model="$storeDossierBourse.Formulaire.NumCompteMarocain"
              :disabled="$storeDossierBourse.Formulaire.ReadOnly"
              :rules="
                ($storeDossierBourse.Formulaire.Lydex &&
                  $storeDossierBourse.Formulaire.Etat ==
                    $storeCatalogue.DataId.EtatDossierBoursePremiereAnnee) ||
                $storeDossierBourse.Formulaire.Programmes.indexOf(
                  $storeCatalogue.ProgrammeGemDataId
                ) > -1
                  ? $storeReglesBourse.CompteMarocain
                  : []
              "
            >
            </v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-row v-show="!this.$storeDossierBourse.Formulaire.ReadOnly">
        <v-col cols="12">
          <v-alert type="info" color="secondary">
            Un seul dossier de bourse est accepté.
            <br />
            Vous pouvez Enregistrer les nouvelles modifications apportées à
            votre demande soit :
            <br />
            - En cliquant sur "Enregistrer" : vous pourrez revenir sur votre
            dossier pour le modifier
            <br />
            - En cliquant sur "Valider" : vous validerez définitivement votre
            dossier et ne pourrez plus le modifier.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-show="!this.$storeDossierBourse.Formulaire.ReadOnly">
        <v-col cols="5">
          <v-btn x-large dark color="secondary" @click="SaveDossier(false)">
            Enregistrer
          </v-btn>
        </v-col>
        <v-col cols="7">
          <v-btn
            x-large
            color="secondary"
            @click="SaveDossier(true)"
            :disabled="!valid"
            v-show="$storeDossierBourse.Formulaire.IdDossierBourse"
          >
            Valider
          </v-btn>
        </v-col>
      </v-row>
      <div v-show="$storeDossierBourse.Formulaire.ResultatVisible">
        <h1>Résultat bourse</h1>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Statut bourse"
              v-model="$storeDossierBourse.Formulaire.StatutBourse"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="4"> </v-col>
        </v-row>
        <v-row v-show="$storeDossierBourse.Formulaire.LienAnnexeBourse">
          <v-col cols="12">
            <a
              target="_blank"
              :href="$storeDossierBourse.Formulaire.LienAnnexeBourse"
              >Attestation de bourse</a
            >
          </v-col>
        </v-row>
        <h1>Echéances de versement</h1>
        <v-data-table
          :headers="headerEcheancier"
          :items="$storeDossierBourse.Formulaire.ListeEcheanciers"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <tr v-if="!item.Supprimer">
              <th class="text-xs-left">{{ item.dateEcheance }}</th>
              <th class="text-xs-left">{{ item.statut }}</th>
              <th class="text-xs-left">{{ item.montantVerse }}</th>
              <th class="text-xs-left">{{ item.devise }}</th>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-form>
    <v-dialog v-model="dialogEmailChange.model" width="500">
      <v-card>
        <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
        <v-card-text>
          <p>{{ $storeUm6p.Label.AdressePrincipaleCompte }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogEmailChange.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert
      border="top"
      color="primary"
      colored-border
      type="info"
      elevation="2"
      v-show="msg_erreur"
    >
      {{ msg_erreur }}
    </v-alert>
  </v-main>
</template>
<script>
import { mdiArrowLeftThick, mdiCurrencyEur } from "@mdi/js";
export default {
  name: "ListeDb",
  data() {
    return {
      icons: {
        mdiArrowLeftThick,
        mdiCurrencyEur,
      },
      token: null,
      loader: false,
      msg_erreur: null,
      $storeDossierBourse: this.$storeDossierBourse,
      $storeCatalogue: this.$storeCatalogue,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeUm6p: this.$storeUm6p,
      dialog: false,
      msg_dialog: null,
      dialogEmailChange: {
        model: false,
      },
      valid: true,
      headerEcheancier: [
        { text: "Date échéance", align: "start", value: "dateecheance" },
        { text: "Statut", align: "start", value: "statut" },
        { text: "Montant versé", align: "start", value: "montantverse" },
        { text: "Devise", align: "start", value: "devise" },
      ],
      IsIban: [
        (v) =>
          !v ||
          (this.$storeDossierBourse.Formulaire.Programmes.indexOf(
            this.$storeCatalogue.ProgrammeGefDataId
          ) > -1 &&
            this.IbanChecked) ||
          "Merci de renseigner un IBAN valide",
      ],
      IbanChecked: false,
    };
  },
  methods: {
    ProvinceChange() {
      this.$storeDossierBourse.Formulaire.RegionMaroc =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.Province,
          this.$storeDossierBourse.Formulaire.ProvinceMaroc
        );
    },
    EtatChange() {
      if (
        this.$storeCatalogue.DataIdStage.includes(
          this.$storeDossierBourse.Formulaire.Etat
        )
      ) {
        this.$storeDossierBourse.Formulaire.Type =
          this.$storeCatalogue.DataId.StageType;
      } else if (
        this.$storeCatalogue.DataIdAlternance.includes(
          this.$storeDossierBourse.Formulaire.Etat
        )
      ) {
        this.$storeDossierBourse.Formulaire.Type =
          this.$storeCatalogue.DataId.AlternanceType;
      } else if (
        this.$storeCatalogue.DataIdContratProfessionnel.includes(
          this.$storeDossierBourse.Formulaire.Etat
        )
      ) {
        this.$storeDossierBourse.Formulaire.Type =
          this.$storeCatalogue.DataId.ContratProType;
      } else {
        this.$storeDossierBourse.Formulaire.Type =
          this.$storeCatalogue.DataId.AucunType;
      }
    },
    IsEmpty(str) {
      if (str) {
        return false;
      } else {
        return true;
      }
    },
    BackToList() {
      window.location.href = "#/ListeDb?t=" + this.token;
    },
    SaveIban() {
      if (
        !this.$storeDossierBourse.Formulaire.Iban ||
        !this.$storeDossierBourse.Formulaire.BIC
      ) {
        this.msg_dialog = "Merci de renseigner l'IBAN et le BIC.";
        this.dialog = true;
        return;
      }
      this.$refs.formulaire.validate();
      if (!this.valid) {
        return;
      }

      var self = this;
      this.loader = true;
      Promise.all([
        this.$storeDossierBourse
          .SaveIban(this.token)
          .then((response) => {
            if (response) {
              if (response.status == 200 && !response.data.msg_erreur) {
                window.location.href = "#/ListeDb?t=" + this.token;
              } else {
                this.msg_dialog = response.data.msg_erreur;
                this.dialog = true;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
          }),
      ]).then(function () {
        self.loader = false;
      });
    },
    SaveDossier(valider) {
      if (valider == true) {
        this.$refs.formulaire.validate();
        if (!this.valid) {
          return;
        }
      }

      var self = this;
      this.loader = true;
      Promise.all([
        this.$storeDossierBourse
          .VerifierIban(this.$storeDossierBourse.Formulaire.Iban)
          .then((response) => {
            if (response) {
              if (response.status == 200) {
                this.IbanChecked = response.data;
                this.$refs.iban.validate();
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
          }),
        this.$storeDossierBourse
          .SaveDossier(this.token, valider)
          .then((response) => {
            if (response) {
              if (response.status == 200 && !response.data.msg_erreur) {
                window.location.href = "#/ListeDb?t=" + this.token;
              } else {
                this.msg_dialog = response.data.msg_erreur;
                this.dialog = true;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
          }),
      ]).then(function () {
        self.loader = false;
      });
    },
    VerifierIban() {
      if (this.$storeDossierBourse.Formulaire.Iban) {
        var self = this;
        this.loader = true;
        Promise.all([
          this.$storeDossierBourse
            .VerifierIban(this.$storeDossierBourse.Formulaire.Iban)
            .then((response) => {
              if (response) {
                if (response.status == 200) {
                  this.IbanChecked = response.data;
                  this.$refs.iban.validate();
                }
              }
            })
            .catch((error) => {
              console.log(error);
              this.loader = false;
            }),
        ]).then(function () {
          self.loader = false;
        });
      }
    },
    ChangementCompteBancaire() {
      if (
        this.$storeDossierBourse.Formulaire.ChangerCompteBancaire &&
        this.$storeDossierBourse.Formulaire.ChangerCompteBancaire ==
          this.$storeCatalogue.DataId.Non
      ) {
        this.$storeDossierBourse.Formulaire.Iban =
          this.$storeDossierBourse.Formulaire.IbanExistant;
      }
    },
    onEmailChange() {
      this.dialogEmailChange.model = true;
    },
  },
  watch: {
    '$storeDossierBourse.Formulaire.DernierEtat': {
      handler(newVal) {
        if (newVal === null) {
          this.$storeDossierBourse.Formulaire.SpecialiteFormation = null;
        }
      },
      immediate: true
    }
  },
  created() {
    document.title = "Liste dossier bourse";
  },
  mounted() {
    let token = this.$route.query.t;
    let id = this.$route.query.nid;
    if (token) {
      this.token = token.replace(/\s/g, "+");
    }

    var self = this;
    this.loader = true;
    Promise.all([
      this.$storeCatalogue.ChargerCataloguesDossierBourse(token),
      this.$storeDossierBourse
        .GetDossier(token, id)
        .then((response) => {
          if (response) {
            if (response.status == 200) {
              if (response.data.msg_erreur) {
                self.msg_erreur = response.data.msg_erreur;
              } else {
                self.msg_erreur = null;
                this.$storeDossierBourse.ParseToFormulaire(
                  response.data.formulaire
                );
                this.valid = this.$storeDossierBourse.Formulaire.EstValidable;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
        }),
    ]).then(function () {
      self.loader = false;
      self.$refs.formulaire.resetValidation();
      self.valid = self.$storeDossierBourse.Formulaire.EstValidable;
    });
  },
};
</script>